import DataExtractor from '../../../public/Images/Recommended Apps/Data_Extractor.png';
import DocumentComparison from '../../../public/Images/Recommended Apps/Document_Comparison.png';
import TermCompiler from '../../../public/Images/Recommended Apps/Disease_Managemenet.png';
import DraftAggrement from '../../../public/Images/Recommended Apps/Draft_Aggrement.png';
import DueDiligence from '../../../public/Images/Recommended Apps/Due_Diligence.png';
import RFPGenerator from '../../../public/Images/Recommended Apps/RFP_Generator.png';
import RenewalManager from '../../../public/Images/Recommended Apps/Renewal_Manager.png';
import VendorProposal from '../../../public/Images/Recommended Apps/Vendor_Proposal.png';
import DiseaseManagement from '../../../public/Images/Recommended Apps/Disease_Managemenet.png';
import ClaimsAnalytics from '../../../public/Images/Recommended Apps/Claims_Analytics.png';
import FiscalControl from '../../../public/Images/Recommended Apps/Fiscal_Control.png';
import MedicalClaim from '../../../public/Images/Recommended Apps/Medical_Claim.png';
import DrugUtilization from '../../../public/Images/Recommended Apps/Drug_Utilization.png';
import PlanAnalysis from '../../../public/Images/Recommended Apps/Plan_Analysis.png';
import ClaimsManagement from '../../../public/Images/Recommended Apps/Claims_Management.png';
import CostManagement from '../../../public/Images/Recommended Apps/Cost_Management.png';
import StopLossManagement from '../../../public/Images/Recommended Apps/Stop_Loss_Management.png';

import DataExtractorDisabled from '../../../public/Images/Recommended Apps/Data_Extractor_Disabled.png';
import DocumentComparisonDisabled from '../../../public/Images/Recommended Apps/Document_Comparison_Disabled.png';
import DraftAggrementDisabled from '../../../public/Images/Recommended Apps/Draft_Aggrement_Disabled.png';
import DueDiligenceDisabled from '../../../public/Images/Recommended Apps/Due_Diligence_Disabled.png';
import RFPGeneratorDisabled from '../../../public/Images/Recommended Apps/RFP_Generator_Disabled.png';
import RenewalManagerDisabled from '../../../public/Images/Recommended Apps/Renewal_Manager_Disabled.png';
import VendorProposalDisabled from '../../../public/Images/Recommended Apps/Vendor_Proposal_Disabled.png';
import RiskProfile from '../../../public/Images/Recommended Apps/Risk_Profile.png';
import PlanDocuments from '../../../public/Images/Recommended Apps/Plan_Docs.png';
import Contracts from '../../../public/Images/Recommended Apps/Contracts.png';
import ComplianceReport from '../../../public/Images/Recommended Apps/Compliance_Report.png';
import Drafts from '../../../public/Images/Recommended Apps/Drafts.png';
import Reports from '../../../public/Images/Recommended Apps/Reports.png';
import StrategyInsightsBoard from '../../../public/Images/Recommended Apps/Strategy_Insights_Board.png';
import DataSphere from '../../../public/Images/Recommended Apps/Data_Sphere.png';
import TaskBoard from '../../../public/Images/Recommended Apps/Task_Board.png';
import ClaimsList from '../../../public/Images/Recommended Apps/Claims_List.png';
import MembersList from '../../../public/Images/Recommended Apps/Member_List.png';
import DeepDive from '../../../public/Images/Recommended Apps/DeepDive.png';

import {
  ACCESS_DASHBOARD,
  COHORT_COMPARISON,
  COMPLIANCE_REPORT,
  CONTRACT_AIQ,
  CUSTOM_QUERY_INTERNAL,
  DATA_CATALOGUE,
  DEEP_DIVE,
  DOC_COMPARISON,
  DRAFT_AGREEMENTS,
  MA_DUE_DILIGENCE,
  MEMBER_LIST,
  PLAN_DOCUMENTS,
  PROPOSAL_ANALYZER,
  REPORTS,
  RISK_REGISTER,
  TASK_BOARD,
  TERM_COMPILER,
  TREND_ANALYSIS,
} from '../routes';
import {
  DocExtractData,
  DocParameter,
  DocReview,
  DocUpload,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

export const RECOMMENDED_APPS = {
  APPS: [
    {
      TITLE: 'M&A Due Diligence',
      IMAGE_E: DueDiligence,
      IMAGE_D: DueDiligenceDisabled,
      DISABLED: false,
      LINK: MA_DUE_DILIGENCE,
    },
    {
      TITLE: 'Document Comparison',
      IMAGE_E: DocumentComparison,
      IMAGE_D: DocumentComparisonDisabled,
      DISABLED: false,
      LINK: DOC_COMPARISON,
    },
    {
      TITLE: 'Term Compiler',
      IMAGE_E: TermCompiler,
      IMAGE_D: TermCompiler,
      DISABLED: false,
      LINK: TERM_COMPILER,
    },
    {
      TITLE: 'Draft Agreement Analyzer',
      IMAGE_E: DraftAggrement,
      IMAGE_D: DraftAggrementDisabled,
      DISABLED: true,
      LINK: '',
    },
    {
      TITLE: 'Vendor Proposal Comparator',
      IMAGE_E: VendorProposal,
      IMAGE_D: VendorProposalDisabled,
      DISABLED: true,
      LINK: '',
    },
    {
      TITLE: 'RFP Generator',
      IMAGE_E: RFPGenerator,
      IMAGE_D: RFPGeneratorDisabled,
      DISABLED: true,
      LINK: '',
    },
    {
      TITLE: 'Renewal Manager',
      IMAGE_E: RenewalManager,
      IMAGE_D: RenewalManagerDisabled,
      DISABLED: true,
      LINK: '',
    },
    {
      TITLE: 'Data Extractor',
      IMAGE_E: DataExtractor,
      IMAGE_D: DataExtractorDisabled,
      DISABLED: true,
      LINK: '',
    },
  ],

  MA_DUE_DILIGENCE: {
    TITLE: 'M&A Due Diligence',
    SUBTITLE:
      'Analyze acquisition documents for risks, liabilities, and due diligence metrics for PE firms',
    TABLE_TITLE: 'Information Extracted',
    CONFIDENCE_SCORE: 'Confidence Score',
    TABS: ['Information Extracted', 'Documents'],
    FILTERS: ['Parameters', 'Confidence Score'],
    CONFIDENCE_SCORES: {
      high: 'High Confidence Score - 90/100',
      medium: 'Medium Confidence Score - 75/100',
      low: 'Low Confidence Score - 65/100',
    },

    CONFIDENCE_SCORE_LIST: [
      {
        name: 'High',
        tooltip:
          'AIQ found consistent, non-conflicting answers across documents or relied on one clearly authoritative source. The final response is strongly supported and does not require assumptions to be considered accurate.',
        color: '#E2F5F5',
      },
      {
        name: 'Medium',
        tooltip:
          'AIQ synthesized multiple answers that were mostly aligned but required judgment to reconcile differences. The conclusion is reasonable but involves assumptions or minor contradictions that introduce uncertainty.',
        color: '#FCEED9',
      },
      {
        name: 'Low',
        tooltip:
          'AIQ found conflicting, ambiguous, or insufficient data across the documents. The final answer is formed with limited support and may not be reliable without further manual validation.',
        color: '#F6E9E9',
      },
    ],

    COMPARISON_TABLE: {
      IN_PROGRESS: 'Comparing Documents',
      NO_DOCS: 'No Documents Uploaded',
      NO_TERMS: 'Terms Not Selected',
      FAILED_COMPILATION: 'Failed Compilation',
      PROCESSING: 'Processing',
    },
    MODAL_TITLE: 'Details and Document Sources',
    DOCUMENT_TABLE_TITLE: 'All Uploaded Documents',

    ADD_PROJECT: {
      GROUP_NAME: 'Group Name',
      TYPE_OF_PLAN: 'Type of Plan',
      TYPE_OF_PLAN_OPTIONS: [
        'Fully Funded Plan',
        'Self Funded Plan',
        'Level Funded Plan',
      ],
      SELECT_CATEGORY: 'Select Category',
      UPLOAD_INFO:
        'Bulk uploads may take some time to complete depending on the file size and number of files.',
      NO_DATA_VISUAL:
        'No categories selected. Select a category to begin your analysis.',
      STEPS: [
        { Icon: DocUpload, title: 'Upload Docket' },
        { Icon: DocParameter, title: 'Select Parameter' },
        { Icon: DocExtractData, title: 'Extracting Data' },
        { Icon: DocReview, title: 'Data Ready for Review' },
      ],
      EXTRACT_DATA: {
        TITLE: 'Data extraction is underway',
        SUBTITLE:
          "You will receive an alert on your email once it's ready for review, or you can return in 60-90 minutes",
        LINK_TITLE: 'Go to Projects Tab',
        LINK: MA_DUE_DILIGENCE,
      },
    },
  },
  DOC_COMPARISON: {
    TITLE: 'Document Comparison Library',
    SUBTITLE:
      'Compare contracts across groups to see where key terms align, vary, or are missing.',
    card: {
      title: 'All Comparison',
      subTitle: 'List of comparison',
      noData: {
        title: 'No document comparison available.',
        subTitle:
          'You haven’t run any comparisons. Start a new comparison to analyze your documents.',
      },
    },
  },
  TERM_COMPILER: {
    TITLE: 'Term Compiler Library',
    SUBTITLE:
      'Browse and search all your term compilations—see status, sources, topics, and evidence at a glance.  Open any to review or export, or click New Compilation to assemble definitions across documents with citations.',
    TABLIST: ['All Compilations'],
    TABLE_TITLE: 'All Contract Extractions',
    COLUMNS: [
      { name: 'Compilation Name' },
      { name: 'Use Case' },
      { name: 'Source(Type-Vendor)' },
      { name: 'Terms Selected' },
      { name: 'Last Updated By' },
      { name: 'Last Updated' },
    ],
    TITLE1: 'Term Compiler',
    CARD_TITLE1: 'Term Compilation Details ',
    SELECTION: 'TERM SELECTION',
    SELECTION_SUBTITLE:
      'Choose the terms/parameters you want extracted from the documents you selected in the previous step.',
    ADD_TERMS: 'Add Terms',
    MENU: ['View', 'Regenerate', 'Delete'],
    CARD: {
      noData: {
        title: 'No Compilations have been generated',
        subTitle: '',
      },
    },
  },
  ANNUAL_RENEWAL_PROCESS: {
    TITLE: 'Annual Renewal Process',
    SUBTITLE:
      'Manage all upcoming contract renewals in one place. Review key details, track renewal dates, and decide whether to extend with the current vendor or initiate a new RFP process. Stay on top of expiring contracts, identify red flags, and ensure smooth vendor transitions with timely actions',
    CARD: {
      TITLE: 'Upcoming Contract Renewals',
      NODATA: 'Start planning for your next renewal cycle',
    },
    BUTTON: {
      ADD_NEW_RENEWAL: 'Add New Agreement Type',
      SUBMIT_BTN: 'Start Renewal',
    },
  },
  PLAYBOOK_AND_STANDARD: {
    TITLE: 'Playbook & Standard',
    SUBTITLE:
      'Streamline Compliance with Automated Workflows: Policies, Contracts, Playbooks & Reports at Your Fingertips',
    CARD: {
      TITLE: 'List of playbooks',
      SUBTITLE: 'Click on a contract to view the playbooks',
      NODATA: 'Start planning for your next renewal cycle',
    },
    BUTTON: {
      ADD_NEW_RENEWAL: 'Add New Agreement Type',
      SUBMIT_BTN: 'Start Renewal',
    },
  },
  COHORT_COMPARISON: {
    TITLE: 'Cohort Comparison Library',
    SUBTITLE:
      'Compare cohorts. Click into any cohort comparison to review details at a glance.',
    card: {
      title: 'All Comparison',
      subTitle: 'List of comparison',
      noData: {
        title: 'No cohort comparison available.',
        subTitle:
          'You haven’t run any comparisons. Start a new comparison to analyze your cohorts.',
      },
    },
  },
  TREND_ANALYSIS: {
    TITLE: 'Trend Analysis Library',
    SUBTITLE: 'Analyze trends and patterns in your data over time.',
    card: {
      title: 'Trend Analysis',
      subTitle: 'List of trend analyses',
      noData: {
        title: 'No trend analyses available.',
        subTitle:
          'You haven’t run any trend analyses. Start a new analysis to explore your data.',
      },
    },
  },
};

export const QUICK_LINKS = {
  APPS: [
    {
      TITLE: 'Claims Analytics',
      IMAGE_E: ClaimsAnalytics,
      IMAGE_D: ClaimsAnalytics,
      DISABLED: false,
      LINK: ACCESS_DASHBOARD,
    },
    {
      TITLE: 'Disease Management',
      IMAGE_E: DiseaseManagement,
      IMAGE_D: DiseaseManagement,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Disease Management')}`,
      DESC:
        'Focuses on insights into the prevalence, progression, and management of diseases within a population, aiming to identify, predict, and evaluate care for chronic conditions and disease risks.',
    },
    {
      TITLE: 'Fiscal Control',
      IMAGE_E: FiscalControl,
      IMAGE_D: FiscalControl,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Fiscal Controls')}`,
      DESC:
        'A single view to review fixed and variable costs, experiment with key variables, and uncover savings.',
    },
    {
      TITLE: 'Medical Claim Utilization',
      IMAGE_E: MedicalClaim,
      IMAGE_D: MedicalClaim,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Medical Claim Utilization')}`,
      DESC:
        'Focuses on the utilization of medical services, aiming to understand patterns in service utilization, identify cost reduction areas, and ensure appropriate use of resources.',
    },
    {
      TITLE: 'Drug Utilization',
      IMAGE_E: DrugUtilization,
      IMAGE_D: DrugUtilization,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Drug Utilization')}`,
      DESC:
        'Analyzes spending and trends in drug utilization, aiming to provide a detailed overview of pharmaceutical expenditures and optimize drug spending.',
    },
    {
      TITLE: 'Plan Analysis',
      IMAGE_E: PlanAnalysis,
      IMAGE_D: PlanAnalysis,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Plan Analysis')}`,
      DESC:
        "Provides a comprehensive analysis of the healthcare plan's performance, including claims cost distribution, enrollment metrics, and the effect of network usage on expenses.",
    },
    {
      TITLE: 'Claims Management',
      IMAGE_E: ClaimsManagement,
      IMAGE_D: ClaimsManagement,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Claims Management')}`,
      DESC:
        'Dedicated to the operational aspect of managing healthcare claims, aiming to improve the efficiency of claims processing and reduce administrative costs.',
    },
    {
      TITLE: 'Cost Management',
      IMAGE_E: CostManagement,
      IMAGE_D: CostManagement,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Cost Management')}`,
      DESC:
        'Analyzes and optimizes healthcare costs associated with medical episodes, identifies wasteful spending, and spotlights high-cost claimants to enhance financial efficiency.',
    },
    {
      TITLE: 'Stop Loss Management',
      IMAGE_E: StopLossManagement,
      IMAGE_D: StopLossManagement,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Stop Loss Management')}`,
      DESC:
        'Manages and mitigates financial risks associated with stop loss insurance, focusing on identifying conditions that trigger stop loss claims, analyzing deductible levels, and evaluating financial impact.',
    },
    {
      TITLE: 'Risk Profile',
      IMAGE_E: RiskProfile,
      IMAGE_D: RiskProfile,
      DISABLED: false,
      LINK: `/dashboard/${encodeURIComponent('Risk Profile')}`,
      DESC:
        'Focuses on categorizing members into risk tiers based on various health and utilization metrics. The goal is to identify and manage high-risk groups effectively, providing insights into their healthcare needs and cost implications.',
    },
    {
      TITLE: 'Plan Documents',
      IMAGE_E: PlanDocuments,
      IMAGE_D: PlanDocuments,
      DISABLED: false,
      LINK: PLAN_DOCUMENTS,
      DESC:
        'Explore the intricacies of your Plan Document with our intelligent search feature, designed to streamline your access to critical information alongside a thorough review report ensuring regulatory compliance.',
    },
    {
      TITLE: 'Contracts',
      IMAGE_E: Contracts,
      IMAGE_D: Contracts,
      DISABLED: false,
      LINK: CONTRACT_AIQ,
      DESC:
        'Command your contractual landscape with a robust document management tool designed to align health plan contracts with precision, ensuring they meet the pinnacle of regulatory compliance and best practices.',
    },
    {
      TITLE: 'Compliance Report',
      IMAGE_E: ComplianceReport,
      IMAGE_D: ComplianceReport,
      DISABLED: false,
      LINK: COMPLIANCE_REPORT,
      DESC:
        'Explore the foundational agreements that govern your employee benefit plan, providing transparency into key partnerships.',
    },
    {
      TITLE: 'Drafts',
      IMAGE_E: Drafts,
      IMAGE_D: Drafts,
      DISABLED: false,
      LINK: DRAFT_AGREEMENTS,
      DESC:
        'Explore the foundational agreements that govern your employee benefit plan, providing transparency into key partnerships.',
    },
    {
      TITLE: 'Reports',
      IMAGE_E: Reports,
      IMAGE_D: Reports,
      DISABLED: false,
      LINK: REPORTS,
      DESC: '',
    },
    {
      TITLE: 'Strategy & Insights Board',
      IMAGE_E: StrategyInsightsBoard,
      IMAGE_D: StrategyInsightsBoard,
      DISABLED: false,
      LINK: RISK_REGISTER,
    },
    {
      TITLE: 'Data Sphere',
      IMAGE_E: DataSphere,
      IMAGE_D: DataSphere,
      DISABLED: false,
      LINK: DATA_CATALOGUE,
    },
    {
      TITLE: 'Task Board',
      IMAGE_E: TaskBoard,
      IMAGE_D: TaskBoard,
      DISABLED: false,
      LINK: TASK_BOARD,
    },
    {
      TITLE: 'Claims List',
      IMAGE_E: ClaimsList,
      IMAGE_D: ClaimsList,
      DISABLED: false,
      LINK: CUSTOM_QUERY_INTERNAL,
    },
    {
      TITLE: 'Members List',
      IMAGE_E: MembersList,
      IMAGE_D: MembersList,
      DISABLED: false,
      LINK: MEMBER_LIST,
    },
    {
      TITLE: 'M&A Due Diligence',
      IMAGE_E: DueDiligence,
      IMAGE_D: DueDiligenceDisabled,
      DISABLED: false,
      LINK: MA_DUE_DILIGENCE,
    },
    {
      TITLE: 'Deep Dive',
      IMAGE_E: DeepDive,
      IMAGE_D: DeepDive,
      DISABLED: false,
      LINK: DEEP_DIVE,
    },
    {
      TITLE: 'Trend Analysis',
      IMAGE_E: DeepDive,
      IMAGE_D: DeepDive,
      DISABLED: false,
      LINK: TREND_ANALYSIS,
    },
    {
      TITLE: 'Cohort Comparison',
      IMAGE_E: DeepDive,
      IMAGE_D: DeepDive,
      DISABLED: false,
      LINK: COHORT_COMPARISON,
    },
    {
      TITLE: 'Drafts',
      IMAGE_E: Drafts,
      IMAGE_D: Drafts,
      DISABLED: false,
      LINK: PROPOSAL_ANALYZER,
      DESC:
        'Explore the foundational agreements that govern your employee benefit plan, providing transparency into key partnerships.',
    },
    // {
    //   TITLE: 'Document Comparison',
    //   IMAGE_E: DocumentComparison,
    //   IMAGE_D: DocumentComparisonDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
    // {
    //   TITLE: 'Draft Agreement Analyzer',
    //   IMAGE_E: DraftAggrement,
    //   IMAGE_D: DraftAggrementDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
    // {
    //   TITLE: 'Vendor Proposal Comparator',
    //   IMAGE_E: VendorProposal,
    //   IMAGE_D: VendorProposalDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
    // {
    //   TITLE: 'RFP Generator',
    //   IMAGE_E: RFPGenerator,
    //   IMAGE_D: RFPGeneratorDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
    // {
    //   TITLE: 'Renewal Manager',
    //   IMAGE_E: RenewalManager,
    //   IMAGE_D: RenewalManagerDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
    // {
    //   TITLE: 'Data Extractor',
    //   IMAGE_E: DataExtractor,
    //   IMAGE_D: DataExtractorDisabled,
    //   DISABLED: true,
    //   LINK: '',
    // },
  ],
};
